import React from 'react'
import { getDateCombination, isImageValidPng } from '../../../../../../commonClass/CommonValidation';

let hotelType = localStorage.getItem('type')?.charAt(0)?.toUpperCase() + localStorage.getItem('type')?.substring(1)?.toLowerCase()
const UploadDocButton = (props) => {
    const {
        mediaType,
        formValue,
        name,
        foldername,
        Fieldname,
        Fieldpath,
        maxfilesize,
        hendlesetdoc,
        setImageSection,
        hotelId,
        disabled,
        setFormError } = props;

    const filterValidImage = (newFiles) => {
        let error = {}
        let newFileType = newFiles?.filter((file) => isImageValidPng(file?.name))
        let newFileSize = newFileType?.filter((file) => ((file?.size / 1024) / 1024) <= maxfilesize)
        if (newFiles?.length !== newFileType?.length) {
            error[Fieldname] = 'Only PNG file type is accepted.';
            setFormError(error);
            return []
        }
        else if (newFiles?.length !== newFileSize?.length) {
            error[Fieldname] = 'Cannot upload file that exceeds 20 MB.';
            setFormError(error);
            return []
        }
        else {
            return newFileSize
        }
    };

    const handleFileChange = (e) => {
        setFormError({});
        const files = Array?.from(e?.target?.files || []);
        let newFiles = filterValidImage(files)
        const imageList = newFiles?.reduce((acc, file, index) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                FileName: filename,
                fieldname: Fieldname,
                FilePath: `CMS/HotelList/${hotelType}/${hotelId}/${foldername?.toLowerCase()}/${filename}`,
                Path: `CMS/HotelList/${hotelType}/${hotelId}/${foldername?.toLowerCase()}/`,
                File: file,
                needToUpload: true,
            });
            return acc
        }, []);

        if (formValue[Fieldname] !== "") {
            setImageSection((prev) => [...prev?.filter(er => er.fieldname !== Fieldname), ...imageList?.filter(er => er.fieldname === Fieldname)])
            hendlesetdoc(Fieldname, Fieldpath, imageList)
        }
        else {
            setImageSection((prev) => [...prev, ...imageList])
            hendlesetdoc(Fieldname, Fieldpath, imageList)
        }
    };

    return (
        <div className='photo-upload-card w-100 h-100' style={{ backgroundColor: '#0777a926' }} key={Fieldname}>
            <label
                htmlFor={`multiImage_uploader_AddRoom${Fieldname}`}
                className='d-flex justify-content-center align-items-center cursor_pointer bg-transparent h-241px'
            >
                <input
                    type="file"
                    className='d-none'
                    name={Fieldname}
                    onChange={handleFileChange}
                    id={`multiImage_uploader_AddRoom${Fieldname}`}
                    accept={mediaType}
                    disabled={disabled ? disabled : Fieldname === 'GSTFileName' ? !formValue?.IsGST : false}
                />

                <div className='text-center py-5'>
                    {name === 'Document' &&
                        <div className=''>
                            <span>
                                <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.83333 34.1248C2.91667 34.1248 2.13194 33.7984 1.47917 33.1457C0.826389 32.4929 0.5 31.7082 0.5 30.7915V7.45817C0.5 6.5415 0.826389 5.75678 1.47917 5.104C2.13194 4.45123 2.91667 4.12484 3.83333 4.12484H10.8333C11.1944 3.12484 11.7986 2.31928 12.6458 1.70817C13.4931 1.09706 14.4444 0.791504 15.5 0.791504C16.5556 0.791504 17.5069 1.09706 18.3542 1.70817C19.2014 2.31928 19.8056 3.12484 20.1667 4.12484H27.1667C28.0833 4.12484 28.8681 4.45123 29.5208 5.104C30.1736 5.75678 30.5 6.5415 30.5 7.45817V18.6248C29.9722 18.3748 29.4306 18.1596 28.875 17.979C28.3194 17.7984 27.75 17.6665 27.1667 17.5832V7.45817H3.83333V30.7915H13.9167C14 31.4026 14.1319 31.9859 14.3125 32.5415C14.4931 33.0971 14.7083 33.6248 14.9583 34.1248H3.83333ZM3.83333 30.7915V7.45817V17.5832V17.4582V30.7915ZM7.16667 27.4582H13.9583C14.0417 26.8748 14.1736 26.3054 14.3542 25.7498C14.5347 25.1943 14.7361 24.6526 14.9583 24.1248H7.16667V27.4582ZM7.16667 20.7915H17.3333C18.2222 19.9582 19.2153 19.2637 20.3125 18.7082C21.4097 18.1526 22.5833 17.7776 23.8333 17.5832V17.4582H7.16667V20.7915ZM7.16667 14.1248H23.8333V10.7915H7.16667V14.1248ZM15.5 6.20817C15.8611 6.20817 16.1597 6.09011 16.3958 5.854C16.6319 5.61789 16.75 5.31928 16.75 4.95817C16.75 4.59706 16.6319 4.29845 16.3958 4.06234C16.1597 3.82623 15.8611 3.70817 15.5 3.70817C15.1389 3.70817 14.8403 3.82623 14.6042 4.06234C14.3681 4.29845 14.25 4.59706 14.25 4.95817C14.25 5.31928 14.3681 5.61789 14.6042 5.854C14.8403 6.09011 15.1389 6.20817 15.5 6.20817ZM25.5 37.4582C23.1944 37.4582 21.2292 36.6457 19.6042 35.0207C17.9792 33.3957 17.1667 31.4304 17.1667 29.1248C17.1667 26.8193 17.9792 24.854 19.6042 23.229C21.2292 21.604 23.1944 20.7915 25.5 20.7915C27.8056 20.7915 29.7708 21.604 31.3958 23.229C33.0208 24.854 33.8333 26.8193 33.8333 29.1248C33.8333 31.4304 33.0208 33.3957 31.3958 35.0207C29.7708 36.6457 27.8056 37.4582 25.5 37.4582ZM24.6667 34.1248H26.3333V29.9582H30.5V28.2915H26.3333V24.1248H24.6667V28.2915H20.5V29.9582H24.6667V34.1248Z" fill="#0777A9" />
                                </svg>
                            </span>
                            <h5 style={{ color: "#0777A9", fontWeight: '700', fontSize: "18px", lineHeight: '27px' }}>Add {name}</h5>
                        </div>

                    }
                    {name === 'Image' &&
                        <div className=''>
                            <span>
                                <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M30.8704 33.4582H16.2748C16.842 32.4777 17.1667 31.3392 17.1667 30.1249L30.8704 30.1249V6.79158H10.1296V23.4684C9.05432 23.5272 8.04688 23.841 7.16667 24.3501V6.79158C7.16667 5.87492 7.45679 5.0902 8.03704 4.43742C8.61728 3.78464 9.31481 3.45825 10.1296 3.45825H30.8704C31.6852 3.45825 32.3827 3.78464 32.963 4.43742C33.5432 5.0902 33.8333 5.87492 33.8333 6.79158V30.1249C33.8333 31.0416 33.5432 31.8263 32.963 32.4791C32.3827 33.1319 31.6852 33.4582 30.8704 33.4582ZM29.3889 26.7916H16.2748C15.6065 25.6363 14.6015 24.7002 13.3939 24.1174L16.0556 20.1249L19.3889 25.1249L23.8333 18.4583L29.3889 26.7916ZM15.5 30.1249C15.5 32.8863 13.2614 35.1249 10.5 35.1249C7.73858 35.1249 5.5 32.8863 5.5 30.1249C5.5 27.3635 7.73858 25.1249 10.5 25.1249C13.2614 25.1249 15.5 27.3635 15.5 30.1249ZM10.0238 30.6011H7.16667V29.6487H10.0238V26.7916H10.9762V29.6487H13.8333V30.6011H10.9762V33.4583H10.0238V30.6011Z"
                                        fill="#0777A9"
                                    />
                                </svg>
                            </span>
                            <h5 style={{ color: "#0777A9", fontWeight: '700', fontSize: "18px", lineHeight: '27px' }}>Add {name}</h5>
                        </div>
                    }
                    <div className='mt-4' style={{ fontWeight: '400', fontSize: "14px", lineHeight: '21px' }}>
                        Accepted file format
                        PDF or PNG
                    </div>
                </div>
            </label>
        </div>
    )
}

export default UploadDocButton